var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.2
    },
    width: 57,
    height: 57,
    x: -61,
    y: -61,
    rx: 2.85,
    ry: 2.85,
    transform: "matrix(0,-1,-1,0,0,0)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#0081cc"
    },
    width: 57,
    height: 57,
    x: -60,
    y: -61,
    rx: 2.85,
    ry: 2.85,
    transform: "matrix(0,-1,-1,0,0,0)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.2
    },
    width: 19,
    height: 38,
    x: 10,
    y: 10,
    rx: 4,
    ry: 4
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    width: 19,
    height: 38,
    x: 10,
    y: 9,
    rx: 4,
    ry: 4
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.2
    },
    width: 20,
    height: 20,
    x: 35,
    y: 10,
    rx: 4,
    ry: 4
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    width: 20,
    height: 20,
    x: 35,
    y: 9,
    rx: 4,
    ry: 4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#ffffff"
    },
    d: "m6.8496094 3c-1.5789 0-2.8496094 1.2707094-2.8496094 2.8496094v1c0-1.5789 1.2707094-2.8496094 2.8496094-2.8496094h51.300782c1.5789 0 2.849609 1.2707094 2.849609 2.8496094v-1c0-1.5789-1.270709-2.8496094-2.849609-2.8496094h-51.300782z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.66c58f310039e001cd53914d3640a94d.svg";
export { ForwardRef as ReactComponent };